import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Constants
import countries from "./countries";
import locales from "./locales";
var formats = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, locales[countries.AT], [{
  "char": /\d/,
  repeat: 2
}, {
  exactly: '/'
}, {
  "char": /\d/,
  repeat: 2
}, {
  exactly: '/'
}, {
  "char": /\d/,
  repeat: 4
}]), locales[countries.DE], [{
  "char": /\d/,
  repeat: 2
}, {
  exactly: '/'
}, {
  "char": /\d/,
  repeat: 2
}, {
  exactly: '/'
}, {
  "char": /\d/,
  repeat: 4
}]), locales[countries.NL], [{
  "char": /\d/,
  repeat: 2
}, {
  exactly: '/'
}, {
  "char": /\d/,
  repeat: 2
}, {
  exactly: '/'
}, {
  "char": /\d/,
  repeat: 4
}]), locales[countries.EN], [{
  "char": /\d/,
  repeat: 2
}, {
  exactly: '/'
}, {
  "char": /\d/,
  repeat: 2
}, {
  exactly: '/'
}, {
  "char": /\d/,
  repeat: 4
}]), locales[countries.ES], [{
  "char": /\d/,
  repeat: 2
}, {
  exactly: '/'
}, {
  "char": /\d/,
  repeat: 2
}, {
  exactly: '/'
}, {
  "char": /\d/,
  repeat: 4
}]);
var uiDisplays = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, locales[countries.AT], 'dd/mm/yyyy'), locales[countries.DE], 'dd/mm/yyyy'), locales[countries.NL], 'dd/mm/yyyy'), locales[countries.EN], 'dd/mm/yyyy'), locales[countries.ES], 'dd/mm/yyyy');
export default {
  formats: formats,
  uiDisplays: uiDisplays
};